/// <reference types="vite/types/importMeta" />
import { GetSFTPEmailResponse } from "./../../responses/internet/sftpConnection.response";
import { Axios } from "axios-observable";
import { map } from "rxjs";
import { apiPathFn } from "@ntprsrf-frontend/common/src/utils/api";
import {
  CreateSFTPRequest,
  UpdateSFTPRequest,
  UpdateSFTPProfileEmailNotificationsRequest,
} from "../../requests/internet/sftpConnection.request";
import { SuccessSingleResponse } from "../../responses/base.response";
import { GetSFTPResponse } from "../../responses/internet/sftpConnection.response";

const apiPathAuth = apiPathFn(import.meta.env.VITE_AUTH_SERVICE);
const apiEZAuth = apiPathFn(import.meta.env.VITE_EZ_AUTH_SERVICE);

export function getSFTPProfile() {
  return Axios.get<GetSFTPResponse>(
    apiPathAuth(["user", "profile", "sftp"])
  ).pipe(map((res) => res.data));
}

export function getSFTPEmails(
  params: Partial<{
    search: string;
  }> = {}
) {
  return Axios.get<GetSFTPEmailResponse>(
    apiPathAuth(["user", "company-user", "sftp", "emails"]),
    {
      params,
    }
  ).pipe(map((res) => res.data));
}

export function getSftpAccountExists() {
  return Axios.get<SuccessSingleResponse<boolean>>(
    apiEZAuth(["sftp", "account", "is-exist"])
  ).pipe(map((res) => res.data));
}

export function createSFTPProfile(request: CreateSFTPRequest) {
  return Axios.post<SuccessSingleResponse<any>>(
    apiEZAuth(["sftp", "create"]),
    request
  ).pipe(map((response) => response.data));
}

export function updateSFTPProfile(request: UpdateSFTPRequest) {
  return Axios.post<SuccessSingleResponse<any>>(
    apiEZAuth(["sftp", "update"]),
    request
  ).pipe(map((response) => response.data));
}

export function deleteSFTPProfile(id: string) {
  return Axios.put(apiEZAuth(["sftp", "delete", id]));
}

export function updateSFTPProfileEmailNotifications(
  id: string,
  request: UpdateSFTPProfileEmailNotificationsRequest
) {
  return Axios.put<SuccessSingleResponse<any>>(
    apiPathAuth(["user", "profile", "sftp", id]),
    request
  ).pipe(map((response) => response.data));
}
